import { BuilderCase } from "./builderCase.js";
/**
 * @class Builder
 * @implements IBuilder
 * @description
 * Builder class to initialize a new builder case instance and return it in order to
 * chain the builder case methods, or onPending, onFulfilled, onRejected methods to define
 * the async action steps.
 */
var Builder = /** @class */ (function () {
    function Builder() {
    }
    /**
     * This method takes an async action object and assign it to the builder case instance
     * @param asyncAction An async action object
     * @returns IBuilderCase
     */
    Builder.prototype.use = function (asyncAction) {
        var builderCase = new BuilderCase();
        builderCase.asyncAction = asyncAction;
        builderCase.cases = [];
        return builderCase;
    };
    return Builder;
}());
export { Builder };
